<!--
    Pageable grid
    [pageSize]="gridState.take"
    [skip]="gridState.skip"
    [pageable]="{ pageSizes: pageSizes }"

    Full size grid
    [pageable]="false"

    (selectionChange)="rowSelected($event)"
 -->
<kendo-grid #loadsGrid
            [data]="gridData"
            [sort]="gridState.sort"
            [filter]="gridState.filter"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="true"
            [sortable]="true"
            [filterable]="true"
            [resizable]="true"
            [autoSize]="true"
            [selectable]="false"
            [rowClass]="rowCallback"
            class="hideFilterOperators"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column title="Action">
        <ng-template kendoGridCellTemplate let-load>
            <button type="button" (click)="addOffer(load)" class="btn btn-primary" [disabled]="originalQuoteOrderLineID==0">
                Add Offer
            </button>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderPriority" title="Priority" [hidden]="viewType == 'RFQ'"></kendo-grid-column>
    <!--<kendo-grid-column field="quoteOrderLineID" title="Quote #"></kendo-grid-column>-->
    <kendo-grid-column field="trailer" title="Trailer"></kendo-grid-column>
    <!--<kendo-grid-column field="loadType" title="Type"></kendo-grid-column>-->
    <kendo-grid-column field="mode" title="Mode"></kendo-grid-column>
    <kendo-grid-column field="rateIndex" title="Rate Index" *ngIf="viewType != 'RFQ'"></kendo-grid-column>
    <kendo-grid-column field="oppTitle" title="Opp Title" *ngIf="viewType == 'RFQ'"></kendo-grid-column>
    <kendo-grid-column field="billTo" title="Bill To"></kendo-grid-column>
    <kendo-grid-column field="originCity" title="O-City"></kendo-grid-column>
    <kendo-grid-column field="originState" title="O-State"></kendo-grid-column>
    <kendo-grid-column field="destinationCity" title="D-City"></kendo-grid-column>
    <kendo-grid-column field="destinationState" title="D-State"></kendo-grid-column>
    <kendo-grid-column field="isRoundTrip" title="RT">
        <ng-template kendoGridCellTemplate let-load>
            <i *ngIf="load.isRoundTrip!=true" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.isRoundTrip==true" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="earliestDate" title="Earliest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.earliestDate == '' ? '' : load.earliestDate | date: 'HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="latstDate" title="Latest">
        <ng-template kendoGridCellTemplate let-load>
            {{load.latestDate == '' ? '' : load.latestDate | date: 'HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="arrivalStartDate" title="Start">
        <ng-template kendoGridCellTemplate let-load>
            {{load.arrivalStartDate == '' ? '' : load.arrivalStartDate | date: 'M/dd'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="orderNumber" title="Order #">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{ load.legNumber}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="offers" title="HC" [hidden]="viewType != 'RFQ'"></kendo-grid-column>
    <kendo-grid-column field="targetCost" title="Target" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="maxCarrierPay" title="Max Pay" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="finalCost" title="Final Cost" format="{0:c}"></kendo-grid-column>
    <!--<kendo-grid-column field="isCostPlus" title="Cost Plus">
        <ng-template kendoGridCellTemplate let-load>
            <i *ngIf="load.isCostPlus!=true" class="far fa-square fa-lg text-secondary"></i>
            <i *ngIf="load.isCostPlus==true" class="fas fa-check-square fa-lg text-primary"></i>
        </ng-template>
    </kendo-grid-column>-->
    <kendo-grid-column field="erpAssignedTo" title="Tags"></kendo-grid-column>
    <kendo-grid-column field="assignedToName" title="Assigned">
        <ng-template kendoGridCellTemplate let-load>
            <!--<a [routerLink]="" (click)="editCarrierReps(load)"><i class="fas fa-pen-square fa-2x text-success"></i></a>-->
            <!--<button (click)="editCarrierReps(load)" class="btn btn-sml btn-success" title="Edit Assigned Reps"><i class="fas fa-pencil-alt text-white"></i></button>-->
            {{load.assignedToName}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="accountManagerName" title="Acct Mgr"></kendo-grid-column>
    <kendo-grid-column field="repsAssigned" title="Reps"></kendo-grid-column>
    <kendo-grid-column field="offers" title="HC" [hidden]="viewType == 'RFQ'"></kendo-grid-column>
    <kendo-grid-column field="minutesSinceLastOffer" title="Last Call"></kendo-grid-column>
    <kendo-grid-column field="minBidRate" title="Min Rate" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="orderPriority" title="Priority" [hidden]="viewType != 'RFQ'"></kendo-grid-column>
</kendo-grid>
